// extracted by mini-css-extract-plugin
module.exports = {"is-mob":"articleFullList_is-mob__J0kWr","is-desk":"articleFullList_is-desk__4xDoz","container__list":"articleFullList_container__list__107yh"};